import { useCallback, useState } from 'react';
import { clearKey } from '../signing/KeyManager';
import { useIdleTimeout } from './useIdleTimeout';
import { ModalType } from '../utils/constants';

export function useKeystoreAuth(openModal: (modal: ModalType, data?: Record<string, any>) => void) {
  const [keystoreUnlocked, setKeystoreUnlocked] = useState(false);
  const [activeNetworkId, setActiveNetworkId] = useState<string | null>(null);

  const handleKeystoreUnlock = useCallback((networkId: string) => {
    setKeystoreUnlocked(true);
    setActiveNetworkId(networkId);
  }, []);

  const handleKeystoreLock = useCallback(() => {
    clearKey();
    setKeystoreUnlocked(false);
    if (activeNetworkId) {
      openModal(ModalType.KeystoreAuthDrawer, {
        networkId: activeNetworkId,
      });
    }
  }, [activeNetworkId, openModal]);

  useIdleTimeout(handleKeystoreLock, 15 * 60 * 1000, keystoreUnlocked);

  return {
    keystoreUnlocked,
    activeNetworkId,
    handleKeystoreUnlock,
    handleKeystoreLock,
  };
}
